import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "252c7173-9f4f-4644-bb1a-2547f6a59fa7",
    content: "Distance of the image source to the receiver divided by speed of sound",
    options: {},
  },
  {
    id: "ef157534-36d2-4ca9-80e6-fb40001434ac",
    content: "Half of the reflection path divided by the speed of sound",
    options: {},
  },
  {
    id: "ed262043-e14a-4bfe-93ce-b1b17ace789a",
    content: "Distance of the image source to the sound source divided by speed of sound",
    options: {},
  },
  {
    id: "63b8c557-92cc-4bea-9de9-3d323a16da35",
    content: "Distance between image source and the wall divided by speed ouf sound",
    options: {},
  },
];

export const task: Task = {
  id: "5dc61af9-9e1a-44c9-bf57-22f420cb6b64",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["252c7173-9f4f-4644-bb1a-2547f6a59fa7"],
};
